export const SELECTION_BAR = {
  CLEAR: 'Clear',
}

export const TABLE_COMPONENT_TEXTS = {
  NO_ROWS: 'No rows',
  TOOLBAR_DENSITY: 'Density',
  TOOLBAR_EXPORT: 'Export',
  TABLE_PAGINATION: {
    LABEL_ROWS_PER_PAGE: 'Rows per page',
    LABEL_DISPLAYED_ROWS: ({ from, to, count }: { from: number; to: number; count: number }) =>
      `${from}–${to} of ${count !== -1 ? count : `more than ${to}`}`,
    GO_TO_FIRST_PAGE: 'Go to first page',
    GO_TO_PREVIOUS_PAGE: 'Go to previous page',
    GO_TO_NEXT_PAGE: 'Go to next page',
    GO_TO_LAST_PAGE: 'Go to last page',
  },
}
